import { AuthRole } from '@newfront-insurance/auth-api';
import { useHasAnyScope } from '@newfront-insurance/next-auth';

import { AuthSwapProvider } from '@/client/providers/auth';

export default function useCanViewClaims(): boolean {
  return useHasAnyScope(AuthSwapProvider, [AuthRole.CLIENT_ADMIN, AuthRole.CLAIM_EDITOR, AuthRole.CLAIM_VIEWER]);
}
